module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "ch9"
    }
  }), _vm._v("FOUNDING JAMESTOWN, 1607")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("W")]), _vm._v("ith failure of the Roanoke Colony, by 1606, England was even more determined to increase its grip on North America. England called the colony Virginia in honor of the King James I cousin and predecessor the Virgin Queen, Elizabeth I. Three ships set sail in December, and after a four-month voyage, the colonists arrived at the mouth of the Chesapeake Bay. They then traveled sixty miles westward and on May 14, 1607, made their settlement Jamestown on a small peninsula on the James River, naming both for England’s reigning king.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Paying for this expedition was the Virginia Company of London, a group of wealthy Englishmen who were convinced that gold, silver, and other riches were there for the taking. They also sought a northwest passage to the riches of the Far East. The company promoted Virginia as a base for English occupation as well as the opportunity for the conversion to Christianity of native peoples. "), _c('span', {
    staticClass: "color"
  }, [_vm._v("(07-066, 07-067)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img21.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3afc5f2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter009.vue
// module id = 102
// module chunks = 0